import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-top"
export default class extends Controller {
  scrollToTop(event) {
    event.preventDefault();
    
    // Find the main content area (the one with overflow-y-auto)
    const container = document.querySelector('main .overflow-y-auto');
    
    if (container) {
      container.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Fallback to window scroll
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}

